'use client';

import { useSelectionStore } from './private/use-selection-store';

/**
 * Quantity selected for the current PDP. Read-only: to change it, use
 * `updateQuantity` from `useSelectionActions`.
 */
export function useSelectedQuantity() {
  const { quantity } = useSelectionStore();

  return { quantity };
}
